import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../api";
import "./Admin.css";
import { stateOptions } from "../../layouts/states";


export const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    minHeight: "27px",
    height: "27px",
    padding: "0 4px",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0",
    height: "25px",
  }),
  input: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    margin: 0,
    padding: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    margin: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    margin: 0,
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
  }),
  menuList: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
  }),
  multiValue: (provided) => ({
    ...provided,
    margin: "0 2px",
    borderRadius: "2px",
    backgroundColor: "#f0f0f0",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    padding: "0 4px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    fontSize: "0.65rem",
    padding: "0 4px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "25px",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: 0,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
  }),
};

const roleOptions = [
  { value: "user", label: "User" },
  { value: "admin", label: "Admin" },
  { value: "team lead", label: "Team Lead" },
];

const departmentOptions = [
  { value: "sales", label: "Sales" },
  { value: "tech", label: "Tech" },
  { value: "hr", label: "HR" },
  { value: "finance", label: "Finance" },
  { value: "executive", label: "Executive" },
];



const CreateAccount = () => {
  const [userData, setUserData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    suffix: "",
    email: "",
    phone: "",
    street: "",
    apt: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    birthday: "",
    active: "y", // not shown in form
    role: [],
    department: [],
    team: [],
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

const [teamOptions, setTeamOptions] = useState([]);

useEffect(() => {
  const fetchTeamOptions = async () => {
    try {
      const res = await api.get("/general/team-options");
      const options = res.data.map((user) => ({
        value: user.id,
        label: user.name,
      }));
      setTeamOptions(options);
    } catch (err) {
      console.error("Error fetching team options:", err);
    }
  };
  fetchTeamOptions();
}, []);


  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // Convert multi-select arrays to comma-separated strings for sending to backend.
    const payload = {
      ...userData,
      role: userData.role.join(", "),
      department: userData.department.join(", "),
      team: userData.team.join(", "),
    };

    try {
      const response = await api.post("/admin/create-user", payload);
      setMessage("User created successfully!");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to create user");
    }
  };

// Updated condition for showing team selection:
const showTeamSelect =
  userData.department.map((dep) => dep.toLowerCase()).includes("sales") &&
  !userData.role.map((r) => r.toLowerCase()).includes("team lead");


  return (
    <div className="admin-container">
      {error && <p className="error">{error}</p>}
      {message && <p className="message">{message}</p>}

      <form onSubmit={handleCreate}>
{/* Row 1: First Name, Middle Initial, Last Name, Suffix */}
<div className="form-row">
  <div className="form-group large-field">
    <label htmlFor="first_name">First</label>
    <input
      type="text"
      id="first_name"
      name="first_name"
      placeholder="First Name"
      onChange={handleChange}
      required
    />
  </div>
  <div className="form-group small-field">
    <label htmlFor="middle_name">Middle</label>
    <input
      type="text"
      id="middle_name"
      name="middle_name"
      placeholder="M"
      maxLength="1"
      onChange={handleChange}
    />
  </div>
  <div className="form-group large-field">
    <label htmlFor="last_name">Last</label>
    <input
      type="text"
      id="last_name"
      name="last_name"
      placeholder="Last Name"
      onChange={handleChange}
      required
    />
  </div>
  <div className="form-group small-field">
    <label htmlFor="suffix">Suffix</label>
    <input
      type="text"
      id="suffix"
      name="suffix"
      placeholder="Suffix"
      onChange={handleChange}
    />
  </div>
</div>


        {/* Row 2: Email and Phone */}
        <div className="form-row">

          <div className="form-group large-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group medium-field">
            <label htmlFor="phone">Phone</label>
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Phone"
              onChange={handleChange}
            />
          </div>
          <div className="form-group small-field">
            <label htmlFor="birthday">Birthday</label>
            <input
              type="date"
              id="birthday"
              name="birthday"
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 3: Street and Apt */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="street">Street</label>
            <input
              type="text"
              id="street"
              name="street"
              placeholder="Street Address"
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="apt">Apt / Suite</label>
            <input
              type="text"
              id="apt"
              name="apt"
              placeholder="Apt, Suite, Unit"
              onChange={handleChange}
            />
          </div>
        </div>

{/* Row 4: City, State, Zip */}
<div className="form-row">
  <div className="form-group">
    <label htmlFor="city">City</label>
    <input
      type="text"
      id="city"
      name="city"
      placeholder="City"
      onChange={handleChange}
    />
  </div>
{/* State Dropdown */}
<div className="form-group">
  <label htmlFor="state">State</label>
  <Select
    id="state"
    name="state"
    options={stateOptions}
    value={stateOptions.filter(opt => userData.state === opt.value)}
    onChange={(selected) =>
      setUserData(prev => ({
        ...prev,
        state: selected ? selected.value : ""
      }))
    }
    placeholder="Select state..."
    styles={customSelectStyles}
  />
</div>

  <div className="form-group">
    <label htmlFor="zip">Zip</label>
    <input
      type="text"
      id="zip"
      name="zip"
      placeholder="Zip Code"
      onChange={handleChange}
    />
  </div>
            <div className="form-group">
            <label htmlFor="country">Country</label>
            <input
              type="text"
              id="country"
              name="country"
              placeholder="Country"
              onChange={handleChange}
            />
          </div>
</div>


        {/* Row 5: Country */}
        <div className="form-row">



        </div>

        {/* Row 7: Role (multi-select) */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="role">Role</label>
            <Select
              id="role"
              name="role"
              isMulti
              options={roleOptions}
              styles={customSelectStyles}
              value={roleOptions.filter(opt => userData.role.includes(opt.value))}
              onChange={(selected) =>
                setUserData((prev) => ({
                  ...prev,
                  role: selected ? selected.map((opt) => opt.value) : [],
                }))
              }
              placeholder="Select role(s)..."
            />
          </div>

          <div className="form-group">
            <label htmlFor="department">Department</label>
            <Select
              id="department"
              name="department"
              isMulti
              options={departmentOptions}
              styles={customSelectStyles}
              value={departmentOptions.filter(opt => userData.department.includes(opt.value))}
              onChange={(selected) =>
                setUserData((prev) => ({
                  ...prev,
                  department: selected ? selected.map((opt) => opt.value) : [],
                }))
              }
              placeholder="Select department(s)..."
            />
          </div>
        </div>

        {showTeamSelect && (
  <div className="form-row">
    <div className="form-group">
      <label htmlFor="team">Team</label>
      <Select
        id="team"
        name="team"
        isMulti
        options={teamOptions}
        styles={customSelectStyles}
        value={teamOptions.filter(opt => userData.team.includes(opt.value))}
        onChange={(selected) =>
          setUserData((prev) => ({
            ...prev,
            team: selected ? selected.map((opt) => opt.value) : [],
          }))
        }
        placeholder="Select team lead(s)..."
      />
    </div>
  </div>
)}

        <button type="submit">Create Account</button>
      </form>
    </div>
  );
};

export default CreateAccount;
